import React from 'react'
import Content from './content'
import useCurrentUser from '../../../hooks/use-current-user'
import useDiscussion from './use-discussion'
import Author from './author'
import { find } from 'lodash'
import Date from './date'

const Participation = ({
    participation = {},
}) => {
    const { id } = useCurrentUser()
    const isMe = id === participation.userId
    const { users } = useDiscussion({ discussionId: participation.discussionId })
    const user = find(users, { id: participation.userId }) || {}
    return (
        <React.Fragment>
            <Content isMe={isMe}>{participation.content}</Content>
            <Author isMe={isMe}>{user.firstName} {user.lastName}</Author>
            <Date value={participation.createdDate} />
        </React.Fragment>
    )
}

export default Participation
